/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const getExampleAudioResultSchema = z.object({
  audioUrl: z.string(),
});

export type IGetExampleAudioResult = z.infer<typeof getExampleAudioResultSchema>;

export const getExampleAudioResponseSchema = createApiResponseSchema(
  getExampleAudioResultSchema,
) as z.ZodSchema<IAPI<IGetExampleAudioResult>>;

export type IGetExampleAudioResponse = IAPI<IGetExampleAudioResult>;
